import { Box, Paper, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { variants } from '../../../../variants/variants';
import { Check, Clear } from '@mui/icons-material';
import SelectAnswer from './SelectAnswer';
import { useDispatch } from 'react-redux';
import { setDraftReason } from '../../giftSlice';
import { useTheme } from '@emotion/react';

const EditBox = ({ index, question, title, designation, handleDisableChange }) => {
  const dispatch = useDispatch();
  const [input, setInput] = useState('');
  const [error, setError] = useState({ error: false, text: '' });
  const theme = useTheme();
  const validate = value => {
    if (value === '') {
      setError({ error: true, text: 'If yes then give reason' });
      handleDisableChange(true);
      return;
    }
    setError({ error: false, text: '' });
    handleDisableChange(false);
  };
  const handleError = showError => {
    if (showError) {
      setError({ error: true, text: 'If yes then give reason' });
      handleDisableChange(true);
      return;
    }
    setError({ error: false, text: '' });
    handleDisableChange(false);
  };
  const handleReason = e => {
    let value = e.target.value;
    setInput(value);
    validate(value);
  };
  useEffect(() => {
    let debounce = setTimeout(() => {
      if (input !== '') {
        dispatch(setDraftReason({ reason: input, designation, title, question: index }));
      }
    }, 500);

    return () => clearTimeout(debounce);
  }, [input]);

  return (
    <Box
      component={Paper}
      sx={{
        mt: 1,
        p: 1,
        background: question?.answer === 'yes' ? variants.color.successBackground : variants.color.errorBackground,
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('lg')]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
        },
      }}
    >
      <Typography sx={{ flex: 0.6, fontSize: variants.BODY, alignItems: 'center', display: 'flex', mr: 1 }}>
        {question?.answer === 'yes' ? (
          <Check fontSize='small' sx={{ mr: 1, color: 'green' }} />
        ) : (
          <Clear fontSize='small' sx={{ mr: 1, color: 'red' }} />
        )}
        {question?.question}
      </Typography>
      <SelectAnswer
        designation={designation}
        title={title}
        question={index}
        editable={true}
        handleError={handleError}
      />
      <TextField
        fullWidth
        defaultValue={question?.reason}
        onChange={handleReason}
        onBlur={e => validate(e.target.value)}
        multiline
        maxRows={4}
        sx={{ ml: 'auto', flex: 0.4, textarea: { fontSize: variants.BODY } }}
        disabled={question?.answer === 'yes' ? false : true}
        error={error.error}
        helperText={error.text}
      />
    </Box>
  );
};

export default EditBox;
